import { InvoiceDetailSlidein } from '@/components/accounts-payable/invoice-detail/invoice-detail-slidein';
import { useNavigate, useParams } from '@tanstack/react-router';

export function Route() {
  const { invoiceId } = useParams({
    from: '/authenticated/accounts-payable/invoices/$invoiceId',
  });
  const navigate = useNavigate();

  return (
    <InvoiceDetailSlidein
      invoiceId={invoiceId}
      isOpen
      onOpenChange={() => {
        navigate({
          to: '..',
          search: true,
          viewTransition: true,
        });
      }}
    />
  );
}
